import React from 'react';
import { Modal } from 'library/ui';

import { JobFormContextProvider } from 'parent-portal/forms/JobFormContext';

import { AutoHireWorkerInnerDialog } from './AutoHireWorkerInnerDialog';

export function AutoHireWorkerDialog({
    open,
    setOpen,
    addressId,
    defaultDay,
}: {
    open: boolean;
    setOpen: (open: boolean) => void;
    addressId?: number;
    defaultDay?: Date;
}) {
    if (!open) return null;

    return (
        <Modal onClose={() => setOpen(false)} width={643}>
            <JobFormContextProvider>
                <AutoHireWorkerInnerDialog setOpen={setOpen} addressId={addressId} defaultDay={defaultDay} />
            </JobFormContextProvider>
        </Modal>
    );
}
